const boxerBuildPackPrices = {
  "default": {
    1:2599,
    2:4899,
    3:6999,
    4:8799,
    5:10399,
    6:11699,
    7:13297,
    8:14598,
    9:15699,
    10:17444,
    11:19189,
    12:20933,
    13:22678,
    14:24422,
    15:26167
  },
  "$25.99": {
    1:2599,
    2:4899,
    3:6999,
    4:8799,
    5:10399,
    6:11699,
    7:13297,
    8:14598,
    9:15699,
    10:17444,
    11:19189,
    12:20933,
    13:22678,
    14:24422,
    15:26167
  },
  "$26.99": {
    1:2699,
    2:5099,
    3:7299,
    4:9199,
    5:10799,
    6:12099,
    7:13799,
    8:15199,
    9:16109,
    10:17899,
    11:19689,
    12:21479,
    13:23269,
    14:25059,
    15:26849
  },
  "$27.99": {
    1:2799,
    2:5299,
    3:7499,
    4:9399,
    5:11099,
    6:12699,
    7:14399,
    8:15799,
    9:16919,
    10:18799,
    11:20679,
    12:22559,
    13:24439,
    14:26319,
    15:28199
  },
  "$29.99": {
    1:2999,
    2:5699,
    3:8099,
    4:10199,
    5:11999,
    6:13599,
    7:15399,
    8:16899,
    9:17999,
    10:19999,
    11:21999,
    12:23999,
    13:25999,
    14:27999,
    15:29999
  }
};

const singleBoxerPrices = {
  "$25.99": 2599,
  "$26.99": 2699,
  "$27.99": 2799,
  "$29.99": 2999,
  "default": 2599
};


// Cart.js
(function() {
  // Public sightglass interface.
  function sightglass(obj, keypath, callback, options) { return new Observer(obj, keypath, callback, options) }
  // Batteries not included.
  sightglass.adapters = {}
  // Constructs a new keypath observer and kicks things off.
  function Observer(obj, keypath, callback, options) {
    this.options = options || {}
    this.options.adapters = this.options.adapters || {}
    this.obj = obj
    this.keypath = keypath
    this.callback = callback
    this.objectPath = []
    this.parse()
    if (isObject(this.target = this.realize())) {
      this.set(true, this.key, this.target, this.callback)
    }
  }
  // Tokenizes the provided keypath string into interface + path tokens for the
  // observer to work with.
  Observer.tokenize = function(keypath, interfaces, root) {
    var tokens = []
    var current = {i: root, path: ''}
    var index, chr
    for (index = 0; index < keypath.length; index++) {
      chr = keypath.charAt(index)
      if (!!~interfaces.indexOf(chr)) {
        tokens.push(current)
        current = {i: chr, path: ''}
      } else {
        current.path += chr
      }
    }
    tokens.push(current)
    return tokens
  }
  // Parses the keypath using the interfaces defined on the view. Sets variables
  // for the tokenized keypath as well as the end key.
  Observer.prototype.parse = function() {
    var interfaces = this.interfaces()
    var root, path
    if (!interfaces.length) {
      error('Must define at least one adapter interface.')
    }
    if (!!~interfaces.indexOf(this.keypath[0])) {
      root = this.keypath[0]
      path = this.keypath.substr(1)
    } else {
      if (typeof (root = this.options.root || sightglass.root) === 'undefined') {
        error('Must define a default root adapter.')
      }
      path = this.keypath
    }
    this.tokens = Observer.tokenize(path, interfaces, root)
    this.key = this.tokens.pop()
  }
  // Realizes the full keypath, attaching observers for every key and correcting
  // old observers to any changed objects in the keypath.
  Observer.prototype.realize = function() {
    var current = this.obj
    var unreached = false
    var prev
    this.tokens.forEach(function(token, index) {
      if (isObject(current)) {
        if (typeof this.objectPath[index] !== 'undefined') {
          if (current !== (prev = this.objectPath[index])) {
            this.set(false, token, prev, this.update.bind(this))
            this.set(true, token, current, this.update.bind(this))
            this.objectPath[index] = current
          }
        } else {
          this.set(true, token, current, this.update.bind(this))
          this.objectPath[index] = current
        }
        current = this.get(token, current)
      } else {
        if (unreached === false) { unreached = index }
        if (prev = this.objectPath[index]) {
          this.set(false, token, prev, this.update.bind(this))
        }
      }
    }, this)
    if (unreached !== false) { this.objectPath.splice(unreached) }
    return current
  }
  // Updates the keypath. This is called when any intermediary key is changed.
  Observer.prototype.update = function() {
    var next, oldValue
    if ((next = this.realize()) !== this.target) {
      if (isObject(this.target)) { this.set(false, this.key, this.target, this.callback) }
      if (isObject(next)) { this.set(true, this.key, next, this.callback) }
      oldValue = this.value()
      this.target = next
      if (this.value() !== oldValue) this.callback()
    }
  }
  // Reads the current end value of the observed keypath. Returns undefined if
  // the full keypath is unreachable.
  Observer.prototype.value = function() {
    if (isObject(this.target)) { return this.get(this.key, this.target) }
  }
  // Sets the current end value of the observed keypath. Calling setValue when
  // the full keypath is unreachable is a no-op.
  Observer.prototype.setValue = function(value) {
    if (isObject(this.target)) { this.adapter(this.key).set(this.target, this.key.path, value) }
  }
  // Gets the provided key on an object.
  Observer.prototype.get = function(key, obj) {
    return this.adapter(key).get(obj, key.path)
  }
  // Observes or unobserves a callback on the object using the provided key.
  Observer.prototype.set = function(active, key, obj, callback) {
    var action = active ? 'observe' : 'unobserve'
    this.adapter(key)[action](obj, key.path, callback)
  }
  // Returns an array of all unique adapter interfaces available.
  Observer.prototype.interfaces = function() {
    var interfaces = Object.keys(this.options.adapters)
    Object.keys(sightglass.adapters).forEach(function(i) {
      if (!~interfaces.indexOf(i)) { interfaces.push(i) }
    })
    return interfaces
  }
  // Convenience function to grab the adapter for a specific key.
  Observer.prototype.adapter = function(key) {
    return this.options.adapters[key.i] || sightglass.adapters[key.i]
  }
  // Unobserves the entire keypath.
  Observer.prototype.unobserve = function() {
    var obj
    this.tokens.forEach(function(token, index) {
      if (obj = this.objectPath[index]) { this.set(false, token, obj, this.update.bind(this)) }
    }, this)
    if (isObject(this.target)) { this.set(false, this.key, this.target, this.callback) }
  }
  // Check if a value is an object than can be observed.
  function isObject(obj) {
    return typeof obj === 'object' && obj !== null
  }
  // Error thrower.
  function error(message) {
    throw new Error('[sightglass] ' + message)
  }
  // Export module for Node and the browser.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = sightglass
  } else if (typeof define === 'function' && define.amd) {
    define([], function() {
      return this.sightglass = sightglass
    })
  } else {
    this.sightglass = sightglass
  }
}).call(this);
// Rivets.js
(function() {
  var Rivets, bindMethod, unbindMethod, _ref,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  Rivets = {
    options: ['prefix', 'templateDelimiters', 'rootInterface', 'preloadData', 'handler'],
    extensions: ['binders', 'formatters', 'components', 'adapters'],
    "public": {
      binders: {},
      components: {},
      formatters: {},
      adapters: {},
      prefix: 'rv',
      templateDelimiters: ['{', '}'],
      rootInterface: '.',
      preloadData: true,
      handler: function(context, ev, binding) { return this.call(context, ev, binding.view.models); },
      configure: function(options) {
        var descriptor, key, option, value;
        if (options == null) { options = {}; }
        for (option in options) {
          value = options[option];
          if (option === 'binders' || option === 'components' || option === 'formatters' || option === 'adapters') {
            for (key in value) {
              descriptor = value[key];
              Rivets[option][key] = descriptor;
            }
          } else {
            Rivets["public"][option] = value;
          }
        }
      },
      bind: function(el, models, options) {
        var view;
        if (models == null) { models = {}; }
        if (options == null) { options = {}; }
        view = new Rivets.View(el, models, options);
        view.bind();
        return view;
      },
      init: function(component, el, data) {
        var scope, view;
        if (data == null) { data = {}; }
        if (el == null) { el = document.createElement('div'); }
        component = Rivets["public"].components[component];
        el.innerHTML = component.template.call(this, el);
        scope = component.initialize.call(this, el, data);
        view = new Rivets.View(el, scope);
        view.bind();
        return view;
      }
    }
  };
  if (window['jQuery'] || window['$']) {
    _ref = 'on' in jQuery.prototype ? ['on', 'off'] : ['bind', 'unbind'], bindMethod = _ref[0], unbindMethod = _ref[1];
    Rivets.Util = {
      bindEvent: function(el, event, handler) { return jQuery(el)[bindMethod](event, handler); },
      unbindEvent: function(el, event, handler) { return jQuery(el)[unbindMethod](event, handler); },
      getInputValue: function(el) {
        var $el;
        $el = jQuery(el);
        if ($el.attr('type') === 'checkbox') {
          return $el.is(':checked');
        } else {
          return $el.val();
        }
      }
    };
  } else {
    Rivets.Util = {
      bindEvent: (function() {
        if ('addEventListener' in window) {
          return function(el, event, handler) { return el.addEventListener(event, handler, false); };
        }
        return function(el, event, handler) { return el.attachEvent('on' + event, handler); };
      })(),
      unbindEvent: (function() {
        if ('removeEventListener' in window) {
          return function(el, event, handler) { return el.removeEventListener(event, handler, false); };
        }
        return function(el, event, handler) { return el.detachEvent('on' + event, handler); };
      })(),
      getInputValue: function(el) {
        var o, _i, _len, _results;
        if (el.type === 'checkbox') {
          return el.checked;
        } else if (el.type === 'select-multiple') {
          _results = [];
          for (_i = 0, _len = el.length; _i < _len; _i++) {
            o = el[_i];
            if (o.selected) { _results.push(o.value); }
          }
          return _results;
        } else {
          return el.value;
        }
      }
    };
  }
  Rivets.TypeParser = (function() {
    function TypeParser() {}
    TypeParser.types = {
      primitive: 0,
      keypath: 1
    };
    TypeParser.parse = function(string) {
      if (/^'.*'$|^".*"$/.test(string)) {
        return {
          type: this.types.primitive,
          value: string.slice(1, -1)
        };
      } else if (string === 'true') {
        return {
          type: this.types.primitive,
          value: true
        };
      } else if (string === 'false') {
        return {
          type: this.types.primitive,
          value: false
        };
      } else if (string === 'null') {
        return {
          type: this.types.primitive,
          value: null
        };
      } else if (string === 'undefined') {
        return {
          type: this.types.primitive,
          value: void 0
        };
      } else if (isNaN(Number(string)) === false) {
        return {
          type: this.types.primitive,
          value: Number(string)
        };
      } else {
        return {
          type: this.types.keypath,
          value: string
        };
      }
    };
    return TypeParser;
  })();
  Rivets.TextTemplateParser = (function() {
    function TextTemplateParser() {}
    TextTemplateParser.types = {
      text: 0,
      binding: 1
    };
    TextTemplateParser.parse = function(template, delimiters) {
      var index, lastIndex, lastToken, length, substring, tokens, value;
      tokens = [];
      length = template.length;
      index = 0;
      lastIndex = 0;
      while (lastIndex < length) {
        index = template.indexOf(delimiters[0], lastIndex);
        if (index < 0) {
          tokens.push({
            type: this.types.text,
            value: template.slice(lastIndex)
          });
          break;
        } else {
          if (index > 0 && lastIndex < index) {
            tokens.push({
              type: this.types.text,
              value: template.slice(lastIndex, index)
            });
          }
          lastIndex = index + delimiters[0].length;
          index = template.indexOf(delimiters[1], lastIndex);
          if (index < 0) {
            substring = template.slice(lastIndex - delimiters[1].length);
            lastToken = tokens[tokens.length - 1];
            if ((lastToken != null ? lastToken.type : void 0) === this.types.text) {
              lastToken.value += substring;
            } else {
              tokens.push({
                type: this.types.text,
                value: substring
              });
            }
            break;
          }
          value = template.slice(lastIndex, index).trim();
          tokens.push({
            type: this.types.binding,
            value: value
          });
          lastIndex = index + delimiters[1].length;
        }
      }
      return tokens;
    };
    return TextTemplateParser;
  })();
  Rivets.View = (function() {
    function View(els, models, options) {
      var k, option, v, _base, _i, _j, _len, _len1, _ref1, _ref2, _ref3, _ref4, _ref5;
      this.els = els;
      this.models = models;
      if (options == null) { options = {}; }
      this.update = __bind(this.update, this);
      this.publish = __bind(this.publish, this);
      this.sync = __bind(this.sync, this);
      this.unbind = __bind(this.unbind, this);
      this.bind = __bind(this.bind, this);
      this.select = __bind(this.select, this);
      this.traverse = __bind(this.traverse, this);
      this.build = __bind(this.build, this);
      this.buildBinding = __bind(this.buildBinding, this);
      this.bindingRegExp = __bind(this.bindingRegExp, this);
      this.options = __bind(this.options, this);
      if (!(this.els.jquery || this.els instanceof Array)) { this.els = [this.els]; }
      _ref1 = Rivets.extensions;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        option = _ref1[_i];
        this[option] = {};
        if (options[option]) {
          _ref2 = options[option];
          for (k in _ref2) {
            v = _ref2[k];
            this[option][k] = v;
          }
        }
        _ref3 = Rivets["public"][option];
        for (k in _ref3) {
          v = _ref3[k];
          if ((_base = this[option])[k] == null) {
            _base[k] = v;
          }
        }
      }
      _ref4 = Rivets.options;
      for (_j = 0, _len1 = _ref4.length; _j < _len1; _j++) {
        option = _ref4[_j];
        this[option] = (_ref5 = options[option]) != null ? _ref5 : Rivets["public"][option];
      }
      this.build();
    }
    View.prototype.options = function() {
      var option, options, _i, _len, _ref1;
      options = {};
      _ref1 = Rivets.extensions.concat(Rivets.options);
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        option = _ref1[_i];
        options[option] = this[option];
      }
      return options;
    };
    View.prototype.bindingRegExp = function() { return new RegExp("^" + this.prefix + "-"); };
    View.prototype.buildBinding = function(binding, node, type, declaration) {
      var context, ctx, dependencies, keypath, options, pipe, pipes;
      options = {};
      pipes = (function() {
        var _i, _len, _ref1, _results;
        _ref1 = declaration.split('|');
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          pipe = _ref1[_i];
          _results.push(pipe.trim());
        }
        return _results;
      })();
      context = (function() {
        var _i, _len, _ref1, _results;
        _ref1 = pipes.shift().split('<');
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          ctx = _ref1[_i];
          _results.push(ctx.trim());
        }
        return _results;
      })();
      keypath = context.shift();
      options.formatters = pipes;
      if (dependencies = context.shift()) {
        options.dependencies = dependencies.split(/\s+/);
      }
      return this.bindings.push(new Rivets[binding](this, node, type, keypath, options));
    };
    View.prototype.build = function() {
      var el, parse, _i, _len, _ref1;
      this.bindings = [];
      parse = (function(_this) {
        return function(node) {
          var block, childNode, delimiters, n, parser, text, token, tokens, _i, _j, _len, _len1, _ref1, _results;
          if (node.nodeType === 3) {
            parser = Rivets.TextTemplateParser;
            if (delimiters = _this.templateDelimiters) {
              if ((tokens = parser.parse(node.data, delimiters)).length) {
                if (!(tokens.length === 1 && tokens[0].type === parser.types.text)) {
                  for (_i = 0, _len = tokens.length; _i < _len; _i++) {
                    token = tokens[_i];
                    text = document.createTextNode(token.value);
                    node.parentNode.insertBefore(text, node);
                    if (token.type === 1) { _this.buildBinding('TextBinding', text, null, token.value); }
                  }
                  node.parentNode.removeChild(node);
                }
              }
            }
          } else if (node.nodeType === 1) { block = _this.traverse(node); }
          if (!block) {
            _ref1 = (function() {
              var _k, _len1, _ref1, _results1;
              _ref1 = node.childNodes;
              _results1 = [];
              for (_k = 0, _len1 = _ref1.length; _k < _len1; _k++) {
                n = _ref1[_k];
                _results1.push(n);
              }
              return _results1;
            })();
            _results = [];
            for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
              childNode = _ref1[_j];
              _results.push(parse(childNode));
            }
            return _results;
          }
        };
      })(this);
      _ref1 = this.els;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        el = _ref1[_i];
        parse(el);
      }
      this.bindings.sort(function(a, b) {
        var _ref2, _ref3;
        return (((_ref2 = b.binder) != null ? _ref2.priority : void 0) || 0) - (((_ref3 = a.binder) != null ? _ref3.priority : void 0) || 0);
      });
    };
    View.prototype.traverse = function(node) {
      var attribute, attributes, binder, bindingRegExp, block, identifier, regexp, type, value, _i, _j, _len, _len1, _ref1, _ref2, _ref3;
      bindingRegExp = this.bindingRegExp();
      block = node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE';
      _ref1 = node.attributes;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        attribute = _ref1[_i];
        if (bindingRegExp.test(attribute.name)) {
          type = attribute.name.replace(bindingRegExp, '');
          if (!(binder = this.binders[type])) {
            _ref2 = this.binders;
            for (identifier in _ref2) {
              value = _ref2[identifier];
              if (identifier !== '*' && identifier.indexOf('*') !== -1) {
                regexp = new RegExp("^" + (identifier.replace(/\*/g, '.+')) + "$");
                if (regexp.test(type)) { binder = value; }
              }
            }
          }
          binder || (binder = this.binders['*']);
          if (binder.block) {
            block = true;
            attributes = [attribute];
          }
        }
      }
      _ref3 = attributes || node.attributes;
      for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
        attribute = _ref3[_j];
        if (bindingRegExp.test(attribute.name)) {
          type = attribute.name.replace(bindingRegExp, '');
          this.buildBinding('Binding', node, type, attribute.value);
        }
      }
      if (!block) {
        type = node.nodeName.toLowerCase();
        if (this.components[type] && !node._bound) {
          this.bindings.push(new Rivets.ComponentBinding(this, node, type));
          block = true;
        }
      }
      return block;
    };
    View.prototype.select = function(fn) {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        if (fn(binding)) { _results.push(binding); }
      }
      return _results;
    };
    View.prototype.bind = function() {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(binding.bind());
      }
      return _results;
    };
    View.prototype.unbind = function() {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(binding.unbind());
      }
      return _results;
    };
    View.prototype.sync = function() {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(typeof binding.sync === "function" ? binding.sync() : void 0);
      }
      return _results;
    };
    View.prototype.publish = function() {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.select(function(b) {
        var _ref1;
        return (_ref1 = b.binder) != null ? _ref1.publishes : void 0;
      });
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(binding.publish());
      }
      return _results;
    };
    View.prototype.update = function(models) {
      var binding, key, model, _i, _len, _ref1, _results;
      if (models == null) { models = {}; }
      for (key in models) {
        model = models[key];
        this.models[key] = model;
      }
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(typeof binding.update === "function" ? binding.update(models) : void 0);
      }
      return _results;
    };
    return View;
  })();
  Rivets.Binding = (function() {
    function Binding(view, el, type, keypath, options) {
      this.view = view;
      this.el = el;
      this.type = type;
      this.keypath = keypath;
      this.options = options != null ? options : {};
      this.getValue = __bind(this.getValue, this);
      this.update = __bind(this.update, this);
      this.unbind = __bind(this.unbind, this);
      this.bind = __bind(this.bind, this);
      this.publish = __bind(this.publish, this);
      this.sync = __bind(this.sync, this);
      this.set = __bind(this.set, this);
      this.eventHandler = __bind(this.eventHandler, this);
      this.formattedValue = __bind(this.formattedValue, this);
      this.parseTarget = __bind(this.parseTarget, this);
      this.observe = __bind(this.observe, this);
      this.setBinder = __bind(this.setBinder, this);
      this.formatters = this.options.formatters || [];
      this.dependencies = [];
      this.formatterObservers = {};
      this.model = void 0;
      this.setBinder();
    }
    Binding.prototype.setBinder = function() {
      var identifier, regexp, value, _ref1;
      if (!(this.binder = this.view.binders[this.type])) {
        _ref1 = this.view.binders;
        for (identifier in _ref1) {
          value = _ref1[identifier];
          if (identifier !== '*' && identifier.indexOf('*') !== -1) {
            regexp = new RegExp("^" + (identifier.replace(/\*/g, '.+')) + "$");
            if (regexp.test(this.type)) {
              this.binder = value;
              this.args = new RegExp("^" + (identifier.replace(/\*/g, '(.+)')) + "$").exec(this.type);
              this.args.shift();
            }
          }
        }
      }
      this.binder || (this.binder = this.view.binders['*']);
      if (this.binder instanceof Function) {
        return this.binder = { routine: this.binder };
      }
    };
    Binding.prototype.observe = function(obj, keypath, callback) {
      return Rivets.sightglass(obj, keypath, callback, {
        root: this.view.rootInterface,
        adapters: this.view.adapters
      });
    };
    Binding.prototype.parseTarget = function() {
      var token;
      token = Rivets.TypeParser.parse(this.keypath);
      if (token.type === 0) {
        return this.value = token.value;
      } else {
        this.observer = this.observe(this.view.models, this.keypath, this.sync);
        return this.model = this.observer.target;
      }
    };
    Binding.prototype.formattedValue = function(value) {
      var ai, arg, args, fi, formatter, id, observer, processedArgs, _base, _i, _j, _len, _len1, _ref1;
      _ref1 = this.formatters;
      for (fi = _i = 0, _len = _ref1.length; _i < _len; fi = ++_i) {
        formatter = _ref1[fi];
        args = formatter.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g);
        id = args.shift();
        formatter = this.view.formatters[id];
        args = (function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = args.length; _j < _len1; _j++) {
            arg = args[_j];
            _results.push(Rivets.TypeParser.parse(arg));
          }
          return _results;
        })();
        processedArgs = [];
        for (ai = _j = 0, _len1 = args.length; _j < _len1; ai = ++_j) {
          arg = args[ai];
          processedArgs.push(arg.type === 0 ? arg.value : ((_base = this.formatterObservers)[fi] || (_base[fi] = {}), !(observer = this.formatterObservers[fi][ai]) ? (observer = this.observe(this.view.models, arg.value, this.sync), this.formatterObservers[fi][ai] = observer) : void 0, observer.value()));
        }
        if ((formatter != null ? formatter.read : void 0) instanceof Function) {
          value = formatter.read.apply(formatter, [value].concat(__slice.call(processedArgs)));
        } else if (formatter instanceof Function) {
          value = formatter.apply(null, [value].concat(__slice.call(processedArgs)));
        }
      }
      return value;
    };
    Binding.prototype.eventHandler = function(fn) {
      var binding, handler;
      handler = (binding = this).view.handler;
      return function(ev) { return handler.call(fn, this, ev, binding); };
    };
    Binding.prototype.set = function(value) {
      var _ref1;
      value = value instanceof Function && !this.binder["function"] ? this.formattedValue(value.call(this.model)) : this.formattedValue(value);
      return (_ref1 = this.binder.routine) != null ? _ref1.call(this, this.el, value) : void 0;
    };
    Binding.prototype.sync = function() {
      var dependency, observer;
      return this.set((function() {
        var _i, _j, _len, _len1, _ref1, _ref2, _ref3;
        if (this.observer) {
          if (this.model !== this.observer.target) {
            _ref1 = this.dependencies;
            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
              observer = _ref1[_i];
              observer.unobserve();
            }
            this.dependencies = [];
            if (((this.model = this.observer.target) != null) && ((_ref2 = this.options.dependencies) != null ? _ref2.length : void 0)) {
              _ref3 = this.options.dependencies;
              for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                dependency = _ref3[_j];
                observer = this.observe(this.model, dependency, this.sync);
                this.dependencies.push(observer);
              }
            }
          }
          return this.observer.value();
        } else {
          return this.value;
        }
      }).call(this));
    };
    Binding.prototype.publish = function() {
      var args, formatter, id, value, _i, _len, _ref1, _ref2, _ref3;
      if (this.observer) {
        value = this.getValue(this.el);
        _ref1 = this.formatters.slice(0).reverse();
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          formatter = _ref1[_i];
          args = formatter.split(/\s+/);
          id = args.shift();
          if ((_ref2 = this.view.formatters[id]) != null ? _ref2.publish : void 0) {
            value = (_ref3 = this.view.formatters[id]).publish.apply(_ref3, [value].concat(__slice.call(args)));
          }
        }
        return this.observer.setValue(value);
      }
    };
    Binding.prototype.bind = function() {
      var dependency, observer, _i, _len, _ref1, _ref2, _ref3;
      this.parseTarget();
      if ((_ref1 = this.binder.bind) != null) { _ref1.call(this, this.el); }
      if ((this.model != null) && ((_ref2 = this.options.dependencies) != null ? _ref2.length : void 0)) {
        _ref3 = this.options.dependencies;
        for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
          dependency = _ref3[_i];
          observer = this.observe(this.model, dependency, this.sync);
          this.dependencies.push(observer);
        }
      }
      if (this.view.preloadData) { return this.sync(); }
    };
    Binding.prototype.unbind = function() {
      var ai, args, fi, observer, _i, _len, _ref1, _ref2, _ref3, _ref4;
      if ((_ref1 = this.binder.unbind) != null) { _ref1.call(this, this.el); }
      if ((_ref2 = this.observer) != null) { _ref2.unobserve(); }
      _ref3 = this.dependencies;
      for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
        observer = _ref3[_i];
        observer.unobserve();
      }
      this.dependencies = [];
      _ref4 = this.formatterObservers;
      for (fi in _ref4) {
        args = _ref4[fi];
        for (ai in args) {
          observer = args[ai];
          observer.unobserve();
        }
      }
      return this.formatterObservers = {};
    };
    Binding.prototype.update = function(models) {
      var _ref1, _ref2;
      if (models == null) { models = {}; }
      this.model = (_ref1 = this.observer) != null ? _ref1.target : void 0;
      return (_ref2 = this.binder.update) != null ? _ref2.call(this, models) : void 0;
    };
    Binding.prototype.getValue = function(el) {
      if (this.binder && (this.binder.getValue != null)) {
        return this.binder.getValue.call(this, el);
      } else {
        return Rivets.Util.getInputValue(el);
      }
    };
    return Binding;
  })();
  Rivets.ComponentBinding = (function(_super) {
    __extends(ComponentBinding, _super);
    function ComponentBinding(view, el, type) {
      var attribute, bindingRegExp, propertyName, _i, _len, _ref1, _ref2;
      this.view = view;
      this.el = el;
      this.type = type;
      this.unbind = __bind(this.unbind, this);
      this.bind = __bind(this.bind, this);
      this.locals = __bind(this.locals, this);
      this.component = this.view.components[this.type];
      this["static"] = {};
      this.observers = {};
      this.upstreamObservers = {};
      bindingRegExp = view.bindingRegExp();
      _ref1 = this.el.attributes || [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        attribute = _ref1[_i];
        if (!bindingRegExp.test(attribute.name)) {
          propertyName = this.camelCase(attribute.name);
          if (__indexOf.call((_ref2 = this.component["static"]) != null ? _ref2 : [], propertyName) >= 0) {
            this["static"][propertyName] = attribute.value;
          } else {
            this.observers[propertyName] = attribute.value;
          }
        }
      }
    }
    ComponentBinding.prototype.sync = function() {};
    ComponentBinding.prototype.update = function() {};
    ComponentBinding.prototype.publish = function() {};
    ComponentBinding.prototype.locals = function() {
      var key, observer, result, value, _ref1, _ref2;
      result = {};
      _ref1 = this["static"];
      for (key in _ref1) {
        value = _ref1[key];
        result[key] = value;
      }
      _ref2 = this.observers;
      for (key in _ref2) {
        observer = _ref2[key];
        result[key] = observer.value();
      }
      return result;
    };
    ComponentBinding.prototype.camelCase = function(string) {
      return string.replace(/-([a-z])/g, function(grouped) { return grouped[1].toUpperCase(); });
    };
    ComponentBinding.prototype.bind = function() {
      var k, key, keypath, observer, option, options, scope, v, _base, _i, _j, _len, _len1, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _results;
      if (!this.bound) {
        _ref1 = this.observers;
        for (key in _ref1) {
          keypath = _ref1[key];
          this.observers[key] = this.observe(this.view.models, keypath, ((function(_this) {
            return function(key) {
              return function() {
                return _this.componentView.models[key] = _this.observers[key].value();
              };
            };
          })(this)).call(this, key));
        }
        this.bound = true;
      }
      if (this.componentView != null) {
        return this.componentView.bind();
      } else {
        this.el.innerHTML = this.component.template.call(this);
        scope = this.component.initialize.call(this, this.el, this.locals());
        this.el._bound = true;
        options = {};
        _ref2 = Rivets.extensions;
        for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
          option = _ref2[_i];
          options[option] = {};
          if (this.component[option]) {
            _ref3 = this.component[option];
            for (k in _ref3) {
              v = _ref3[k];
              options[option][k] = v;
            }
          }
          _ref4 = this.view[option];
          for (k in _ref4) {
            v = _ref4[k];
            if ((_base = options[option])[k] == null) { _base[k] = v; }
          }
        }
        _ref5 = Rivets.options;
        for (_j = 0, _len1 = _ref5.length; _j < _len1; _j++) {
          option = _ref5[_j];
          options[option] = (_ref6 = this.component[option]) != null ? _ref6 : this.view[option];
        }
        this.componentView = new Rivets.View(this.el, scope, options);
        this.componentView.bind();
        _ref7 = this.observers;
        _results = [];
        for (key in _ref7) {
          observer = _ref7[key];
          _results.push(this.upstreamObservers[key] = this.observe(this.componentView.models, key, ((function(_this) {
            return function(key, observer) {
              return function() {
                return observer.setValue(_this.componentView.models[key]);
              };
            };
          })(this)).call(this, key, observer)));
        }
        return _results;
      }
    };
    ComponentBinding.prototype.unbind = function() {
      var key, observer, _ref1, _ref2, _ref3;
      _ref1 = this.upstreamObservers;
      for (key in _ref1) {
        observer = _ref1[key];
        observer.unobserve();
      }
      _ref2 = this.observers;
      for (key in _ref2) {
        observer = _ref2[key];
        observer.unobserve();
      }
      return (_ref3 = this.componentView) != null ? _ref3.unbind.call(this) : void 0;
    };
    return ComponentBinding;
  })(Rivets.Binding);
  Rivets.TextBinding = (function(_super) {
    __extends(TextBinding, _super);
    function TextBinding(view, el, type, keypath, options) {
      this.view = view;
      this.el = el;
      this.type = type;
      this.keypath = keypath;
      this.options = options != null ? options : {};
      this.sync = __bind(this.sync, this);
      this.formatters = this.options.formatters || [];
      this.dependencies = [];
      this.formatterObservers = {};
    }
    TextBinding.prototype.binder = {
      routine: function(node, value) { return node.data = value != null ? value : ''; }
    };
    TextBinding.prototype.sync = function() { return TextBinding.__super__.sync.apply(this, arguments); };
    return TextBinding;
  })(Rivets.Binding);
  Rivets["public"].binders.text = function(el, value) {
    if (el.textContent != null) {
      return el.textContent = value != null ? value : '';
    } else {
      return el.innerText = value != null ? value : '';
    }
  };
  Rivets["public"].binders.html = function(el, value) { return el.innerHTML = value != null ? value : ''; };
  Rivets["public"].binders.show = function(el, value) { return el.style.display = value ? '' : 'none'; };
  Rivets["public"].binders.hide = function(el, value) { return el.style.display = value ? 'none' : ''; };
  Rivets["public"].binders.enabled = function(el, value) { return el.disabled = !value; };
  Rivets["public"].binders.disabled = function(el, value) { return el.disabled = !!value; };
  Rivets["public"].binders.checked = {
    publishes: true,
    priority: 2000,
    bind: function(el) { return Rivets.Util.bindEvent(el, 'change', this.publish); },
    unbind: function(el) { return Rivets.Util.unbindEvent(el, 'change', this.publish); },
    routine: function(el, value) {
      var _ref1;
      if (el.type === 'radio') {
        return el.checked = ((_ref1 = el.value) != null ? _ref1.toString() : void 0) === (value != null ? value.toString() : void 0);
      } else { return el.checked = !!value; }
    }
  };
  Rivets["public"].binders.unchecked = {
    publishes: true,
    priority: 2000,
    bind: function(el) { return Rivets.Util.bindEvent(el, 'change', this.publish); },
    unbind: function(el) { return Rivets.Util.unbindEvent(el, 'change', this.publish); },
    routine: function(el, value) {
      var _ref1;
      if (el.type === 'radio') {
        return el.checked = ((_ref1 = el.value) != null ? _ref1.toString() : void 0) !== (value != null ? value.toString() : void 0);
      } else { return el.checked = !value; }
    }
  };
  Rivets["public"].binders.value = {
    publishes: true,
    priority: 3000,
    bind: function(el) {
      if (!(el.tagName === 'INPUT' && el.type === 'radio')) {
        this.event = el.tagName === 'SELECT' ? 'change' : 'input';
        return Rivets.Util.bindEvent(el, this.event, this.publish);
      }
    },
    unbind: function(el) {
      if (!(el.tagName === 'INPUT' && el.type === 'radio')) { return Rivets.Util.unbindEvent(el, this.event, this.publish); }
    },
    routine: function(el, value) {
      var o, _i, _len, _ref1, _ref2, _ref3, _results;
      if (el.tagName === 'INPUT' && el.type === 'radio') {
        return el.setAttribute('value', value);
      } else if (window.jQuery != null) {
        el = jQuery(el);
        if ((value != null ? value.toString() : void 0) !== ((_ref1 = el.val()) != null ? _ref1.toString() : void 0)) {
          return el.val(value != null ? value : '');
        }
      } else {
        if (el.type === 'select-multiple') {
          if (value != null) {
            _results = [];
            for (_i = 0, _len = el.length; _i < _len; _i++) {
              o = el[_i];
              _results.push(o.selected = (_ref2 = o.value, __indexOf.call(value, _ref2) >= 0));
            }
            return _results;
          }
        } else if ((value != null ? value.toString() : void 0) !== ((_ref3 = el.value) != null ? _ref3.toString() : void 0)) {
          return el.value = value != null ? value : '';
        }
      }
    }
  };
  Rivets["public"].binders["if"] = {
    block: true,
    priority: 4000,
    bind: function(el) {
      var attr, declaration;
      if (this.marker == null) {
        attr = [this.view.prefix, this.type].join('-').replace('--', '-');
        declaration = el.getAttribute(attr);
        this.marker = document.createComment(" rivets: " + this.type + " " + declaration + " ");
        this.bound = false;
        el.removeAttribute(attr);
        el.parentNode.insertBefore(this.marker, el);
        return el.parentNode.removeChild(el);
      }
    },
    unbind: function() {
      var _ref1;
      return (_ref1 = this.nested) != null ? _ref1.unbind() : void 0;
    },
    routine: function(el, value) {
      var key, model, models, _ref1;
      if (!!value === !this.bound) {
        if (value) {
          models = {};
          _ref1 = this.view.models;
          for (key in _ref1) {
            model = _ref1[key];
            models[key] = model;
          }
          (this.nested || (this.nested = new Rivets.View(el, models, this.view.options()))).bind();
          this.marker.parentNode.insertBefore(el, this.marker.nextSibling);
          return this.bound = true;
        } else {
          el.parentNode.removeChild(el);
          this.nested.unbind();
          return this.bound = false;
        }
      }
    },
    update: function(models) {
      var _ref1;
      return (_ref1 = this.nested) != null ? _ref1.update(models) : void 0;
    }
  };
  Rivets["public"].binders.unless = {
    block: true,
    priority: 4000,
    bind: function(el) { return Rivets["public"].binders["if"].bind.call(this, el); },
    unbind: function() { return Rivets["public"].binders["if"].unbind.call(this); },
    routine: function(el, value) { return Rivets["public"].binders["if"].routine.call(this, el, !value); },
    update: function(models) { return Rivets["public"].binders["if"].update.call(this, models); }
  };
  Rivets["public"].binders['on-*'] = {
    "function": true,
    priority: 1000,
    unbind: function(el) {
      if (this.handler) { return Rivets.Util.unbindEvent(el, this.args[0], this.handler); }
    },
    routine: function(el, value) {
      if (this.handler) { Rivets.Util.unbindEvent(el, this.args[0], this.handler); }
      return Rivets.Util.bindEvent(el, this.args[0], this.handler = this.eventHandler(value));
    }
  };
  Rivets["public"].binders['each-*'] = {
    block: true,
    priority: 4000,
    bind: function(el) {
      var attr, view, _i, _len, _ref1;
      if (this.marker == null) {
        attr = [this.view.prefix, this.type].join('-').replace('--', '-');
        this.marker = document.createComment(" rivets: " + this.type + " ");
        this.iterated = [];
        el.removeAttribute(attr);
        el.parentNode.insertBefore(this.marker, el);
        el.parentNode.removeChild(el);
      } else {
        _ref1 = this.iterated;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          view = _ref1[_i];
          view.bind();
        }
      }
    },
    unbind: function(el) {
      var view, _i, _len, _ref1, _results;
      if (this.iterated != null) {
        _ref1 = this.iterated;
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          view = _ref1[_i];
          _results.push(view.unbind());
        }
        return _results;
      }
    },
    routine: function(el, collection) {
      var binding, data, i, index, key, model, modelName, options, previous, template, view, _i, _j, _k, _len, _len1, _len2, _ref1, _ref2, _ref3, _results;
      modelName = this.args[0];
      collection = collection || [];
      if (this.iterated.length > collection.length) {
        _ref1 = Array(this.iterated.length - collection.length);
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          i = _ref1[_i];
          view = this.iterated.pop();
          view.unbind();
          this.marker.parentNode.removeChild(view.els[0]);
        }
      }
      for (index = _j = 0, _len1 = collection.length; _j < _len1; index = ++_j) {
        model = collection[index];
        data = { index: index };
        data[modelName] = model;
        if (this.iterated[index] == null) {
          _ref2 = this.view.models;
          for (key in _ref2) {
            model = _ref2[key];
            if (data[key] == null) { data[key] = model; }
          }
          previous = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker;
          options = this.view.options();
          options.preloadData = true;
          template = el.cloneNode(true);
          view = new Rivets.View(template, data, options);
          view.bind();
          this.iterated.push(view);
          this.marker.parentNode.insertBefore(template, previous.nextSibling);
        } else if (this.iterated[index].models[modelName] !== model) {
          this.iterated[index].update(data);
        }
      }
      if (el.nodeName === 'OPTION') {
        _ref3 = this.view.bindings;
        _results = [];
        for (_k = 0, _len2 = _ref3.length; _k < _len2; _k++) {
          binding = _ref3[_k];
          if (binding.el === this.marker.parentNode && binding.type === 'value') {
            _results.push(binding.sync());
          } else { _results.push(void 0); }
        }
        return _results;
      }
    },
    update: function(models) {
      var data, key, model, view, _i, _len, _ref1, _results;
      data = {};
      for (key in models) {
        model = models[key];
        if (key !== this.args[0]) {
          data[key] = model;
        }
      }
      _ref1 = this.iterated;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        view = _ref1[_i];
        _results.push(view.update(data));
      }
      return _results;
    }
  };
  Rivets["public"].binders['class-*'] = function(el, value) {
    var elClass;
    elClass = " " + el.className + " ";
    if (!value === (elClass.indexOf(" " + this.args[0] + " ") !== -1)) {
      return el.className = value ? "" + el.className + " " + this.args[0] : elClass.replace(" " + this.args[0] + " ", ' ').trim();
    }
  };
  Rivets["public"].binders['*'] = function(el, value) {
    if (value != null) {
      return el.setAttribute(this.type, value);
    } else { return el.removeAttribute(this.type); }
  };
  Rivets["public"].adapters['.'] = {
    id: '_rv',
    counter: 0,
    weakmap: {},
    weakReference: function(obj) {
      var id, _base, _name;
      if (!obj.hasOwnProperty(this.id)) {
        id = this.counter++;
        Object.defineProperty(obj, this.id, {
          value: id
        });
      }
      return (_base = this.weakmap)[_name = obj[this.id]] || (_base[_name] = { callbacks: {} });
    },
    cleanupWeakReference: function(ref, id) {
      if (!Object.keys(ref.callbacks).length) {
        if (!(ref.pointers && Object.keys(ref.pointers).length)) { return delete this.weakmap[id]; }
      }
    },
    stubFunction: function(obj, fn) {
      var map, original, weakmap;
      original = obj[fn];
      map = this.weakReference(obj);
      weakmap = this.weakmap;
      return obj[fn] = function() {
        var callback, k, r, response, _i, _len, _ref1, _ref2, _ref3, _ref4;
        response = original.apply(obj, arguments);
        _ref1 = map.pointers;
        for (r in _ref1) {
          k = _ref1[r];
          _ref4 = (_ref2 = (_ref3 = weakmap[r]) != null ? _ref3.callbacks[k] : void 0) != null ? _ref2 : [];
          for (_i = 0, _len = _ref4.length; _i < _len; _i++) {
            callback = _ref4[_i];
            callback();
          }
        }
        return response;
      };
    },
    observeMutations: function(obj, ref, keypath) {
      var fn, functions, map, _base, _i, _len;
      if (Array.isArray(obj)) {
        map = this.weakReference(obj);
        if (map.pointers == null) {
          map.pointers = {};
          functions = ['push', 'pop', 'shift', 'unshift', 'sort', 'reverse', 'splice'];
          for (_i = 0, _len = functions.length; _i < _len; _i++) {
            fn = functions[_i];
            this.stubFunction(obj, fn);
          }
        }
        if ((_base = map.pointers)[ref] == null) { _base[ref] = []; }
        if (__indexOf.call(map.pointers[ref], keypath) < 0) { return map.pointers[ref].push(keypath); }
      }
    },
    unobserveMutations: function(obj, ref, keypath) {
      var idx, map, pointers;
      if (Array.isArray(obj) && (obj[this.id] != null)) {
        if (map = this.weakmap[obj[this.id]]) {
          if (pointers = map.pointers[ref]) {
            if ((idx = pointers.indexOf(keypath)) >= 0) { pointers.splice(idx, 1); }
            if (!pointers.length) { delete map.pointers[ref]; }
            return this.cleanupWeakReference(map, obj[this.id]);
          }
        }
      }
    },
    observe: function(obj, keypath, callback) {
      var callbacks, desc, value;
      callbacks = this.weakReference(obj).callbacks;
      if (callbacks[keypath] == null) {
        callbacks[keypath] = [];
        desc = Object.getOwnPropertyDescriptor(obj, keypath);
        if (!((desc != null ? desc.get : void 0) || (desc != null ? desc.set : void 0))) {
          value = obj[keypath];
          Object.defineProperty(obj, keypath, {
            enumerable: true,
            get: function() { return value; },
            set: (function(_this) {
              return function(newValue) {
                var map, _i, _len, _ref1;
                if (newValue !== value) {
                  _this.unobserveMutations(value, obj[_this.id], keypath);
                  value = newValue;
                  if (map = _this.weakmap[obj[_this.id]]) {
                    callbacks = map.callbacks;
                    if (callbacks[keypath]) {
                      _ref1 = callbacks[keypath].slice();
                      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                        callback = _ref1[_i];
                        if (__indexOf.call(callbacks[keypath], callback) >= 0) { callback(); }
                      }
                    }
                    return _this.observeMutations(newValue, obj[_this.id], keypath);
                  }
                }
              };
            })(this)
          });
        }
      }
      if (__indexOf.call(callbacks[keypath], callback) < 0) { callbacks[keypath].push(callback); }
      return this.observeMutations(obj[keypath], obj[this.id], keypath);
    },
    unobserve: function(obj, keypath, callback) {
      var callbacks, idx, map;
      if (map = this.weakmap[obj[this.id]]) {
        if (callbacks = map.callbacks[keypath]) {
          if ((idx = callbacks.indexOf(callback)) >= 0) {
            callbacks.splice(idx, 1);
            if (!callbacks.length) { delete map.callbacks[keypath]; }
          }
          this.unobserveMutations(obj[keypath], obj[this.id], keypath);
          return this.cleanupWeakReference(map, obj[this.id]);
        }
      }
    },
    get: function(obj, keypath) { return obj[keypath]; },
    set: function(obj, keypath, value) { return obj[keypath] = value; }
  };
  Rivets.factory = function(sightglass) {
    Rivets.sightglass = sightglass;
    Rivets["public"]._ = Rivets;
    return Rivets["public"];
  };
  if (typeof (typeof module !== "undefined" && module !== null ? module.exports : void 0) === 'object') {
    module.exports = Rivets.factory(require('sightglass'));
  } else if (typeof define === 'function' && define.amd) {
    define(['sightglass'], function(sightglass) { return this.rivets = Rivets.factory(sightglass); });
  } else {
    this.rivets = Rivets.factory(sightglass);
  }
}).call(this);
(function() {
  var $document, Cart, CartJS, Item, processing, queue,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  Cart = (function() {
    function Cart() { this.update = __bind(this.update, this); }
    Cart.prototype.update = function(cart) {
      var item, key, value;
      for (key in cart) {
        value = cart[key];
        if (key !== 'items') { this[key] = value; }
      }
      // start by collecting the joined and unjoined products separately
      var joinedProducts = {};
      var unJoinedProducts = [];
      var joinedProductCookie = CartCookie.getJoinedItems();
      var emptyJoinedProducts = ( joinedProductCookie.length ? false : true );
      for ( var _i in cart.items) {
        if(cart.items[_i].handle.indexOf('-joinedproduct') !== -1) {
          var jp = {'item': cart.items[_i], 'quantity' : cart.items[_i].quantity};
          joinedProducts[cart.items[_i].id] = jp;
        } else { unJoinedProducts.push(cart.items[_i]); }
      }
      return this.items = (function() {
        var _i, _len, _ref, _results;
        _ref = cart.items;
        _results = [];
        for ( var _i in unJoinedProducts) {
          item = unJoinedProducts[_i];
          item.hasJoined = false;
          item.total_quantity = item.quantity;
          item.unit_price = item.line_price/item.quantity;
          var total_quantity = item.quantity;
          // console.log("Marker");
          // does this unjoined product have a joined product?
          for( var _j in joinedProductCookie ) {
            var thisitem = $.extend( true, {}, item );
            thisitem.joinedProducts = [];
            if( thisitem.id == joinedProductCookie[_j].parentId && joinedProductCookie[_j].joinedIds.length > 0) {
              thisitem.quantity = parseInt(joinedProductCookie[_j].quantity);
              thisitem.line_price = thisitem.unit_price*thisitem.quantity;
              // console.log("Quant Setter");
              total_quantity = total_quantity - thisitem.quantity;
              for( var _k in joinedProductCookie[_j].joinedIds) {
                var joinedId = joinedProductCookie[_j].joinedIds[_k];
                if(joinedProducts[joinedId] !== undefined) {
                  thisitem.hasJoined = true;
                  thisitem.joinedProducts.push(joinedProducts[joinedId].item);
                  thisitem.title = thisitem.title + ', ' + joinedProducts[joinedId].item.variant_title;
                  thisitem.line_price = thisitem.line_price + (joinedProducts[joinedId].item.line_price/joinedProducts[joinedId].item.quantity*thisitem.quantity);
                  thisitem.variant_title = thisitem.variant_title + '\n' + joinedProducts[joinedId].item.variant_title;

                  // add the joined product to the results
                  var jp = $.extend( true, {}, joinedProducts[joinedId].item );
                  jp.isJoined = true;
                  jp.parentProduct = thisitem;
                  jp.quantity = thisitem.quantity;
                  _results.push(new Item(jp));
                  joinedProducts[joinedId].quantity = joinedProducts[joinedId].quantity - thisitem.quantity;
                  if(joinedProducts[joinedId].quantity <= 0) delete joinedProducts[joinedId];
                }
              }

              // add the item to cart
              _results.push(new Item(thisitem));
            }
          }
          for ( var _z in unJoinedProducts) {
            if(item["variant_id"] == unJoinedProducts[_z]["variant_id"] && item["properties"] == unJoinedProducts[_z]["properties"]) {
              // console.log("Delete here;");
              delete unJoinedProducts[_z];
            }
          }

          // if the cookie is gone, check against joined items
          // console.log("Empty JP");
          if(emptyJoinedProducts) {
            for( var _j in joinedProducts) {
              if(item.handle + '-joinedproduct' == joinedProducts[_j].item.handle || item.handle + '-joinedproduct2' == joinedProducts[_j].item.handle) {
                total_quantity = 0;
                // console.log('removing item: ' + item.id);
                // addTUBAction({ 'action' : 'emptyJoinedParentProducts', 'value' : {'id': item.id, 'quantity': 0} });
                CartJS.Core.updateItemById(item.id, 0);
                // console.log('removing item: ' + joinedProducts[_j].item.id);
                // addTUBAction({ 'action' : 'emptyJoinedChildProducts', 'value' : {'id': joinedProducts[_j].item.id, 'quantity': 0} });
                CartJS.Core.updateItemById(joinedProducts[_j].item.id, 0);
              }
            }
          }
          // console.log("CHANGED - Q Check");
          if(total_quantity > 0) {
            var thisitem = $.extend( true, {}, item );
            thisitem.quantity = total_quantity;
            thisitem.line_price = thisitem.unit_price*thisitem.quantity;
            _results.push(new Item(thisitem));
          }
        }
        // confirm there are no leftover joined products in the cart (delete them!)
        for( var _j in joinedProducts) {
          // get the quantity difference
          var quantity = 0;
          for ( var _i in _ref) {
            if(_ref[_i].id == _j) {
              quantity = _ref[_i].quantity - joinedProducts[_j].quantity;
              break;
            }
          }
          if(quantity >= 0) CartJS.Core.updateItemById(_j, quantity);
        }
        return _results;
      })();
    };
    return Cart;
  })();
  Item = (function() {
    function Item(item) {
      this.propertyArray = __bind(this.propertyArray, this);
      this.update = __bind(this.update, this);
      this.update(item);
    }
    Item.prototype.update = function(item) {
      // console.log('item prototype');
      // console.log(item);

      if(item.product_type == 'Conjured Subscription') {
        var ptype = ''
        if (item.handle == 'monthly-boxer-subscription'){
          ptype = 'Monthly Boxer'
        }else if ( item.handle == 'quarterly-boxer-subscription'){
          ptype = 'Quarterly Boxer'
        }else if ( item.handle == 'monthly-long-boxer-subscription'){
          ptype = 'Long Boxer'
        }else if ( item.handle == 'monthly-boxer-brief-subscription'){
          ptype = 'Brief Boxer'
        }else if ( item.handle == 'monthly-boxer-trunk-subscription'){
          ptype = 'Trunk Boxer'
        }else if (item.handle == 'monthly-thong-subscription'){
          ptype = 'Thong'
        }else if (item.handle == 'monthly-cheeky-subscription'){
            ptype = 'Cheeky'
        }else if (item.handle == 'monthly-boyshort-underwear-subscription'){
            ptype = 'Boyshort'
        }else if (item.handle == 'monthly-bikini-underwear-subscription'){
            ptype = 'Bikini'
        }else if (item.handle == 'monthly-boxer-thong-subscription'){
            ptype = 'Matching Underwear'
        }else{
          // console.log("Dont set variant_title");
        }
        if(ptype && ptype.length > 0){
          if(item.variant_options[0] == 'Gift') {
            item.product_title = 'Gift '+ptype+' Subscription';
            switch(item.variant_options[1]) {
              case '1':
                item.variant_title = '1 Month for ' + item.properties._recipient_first_name + ' ' + item.properties._recipient_last_name;
                break;
              case '3':
                item.variant_title = '3 Months for ' + item.properties._recipient_first_name + ' ' + item.properties._recipient_last_name;
                break;
              case '6':
                item.variant_title = '6 Months for ' + item.properties._recipient_first_name + ' ' + item.properties._recipient_last_name;
                break;
              case '12':
                item.variant_title = '12 Months for ' + item.properties._recipient_first_name + ' ' + item.properties._recipient_last_name;
                break;
            }
          } else if (ptype == 'Matching Underwear') {
            item.product_title = ptype+' Subscription';
            item.title = ptype+' Subscription';
            item.variant_title = item.properties['Boxer_Size'] + ' Boxer' + '\n' + item.properties['Thong_Size'] + ' ' + item.properties['Womens_Style']
          } else {
            try{
              item.title = item.title.split(' - ')[0];
              item.first_pair = 'First Pair:' + '\n' + item.properties["First Pair"].split(' | ')[0];
            }catch(e){
              item.title = item.title;
              item.first_pair = ''
            }
            item.product_title = ptype+' Subscription';
            var s_min = item.properties.Size;
            var st_min = item.properties.Style;
            switch(item.properties.Size){
              case 'Extra Small':
                s_min = "XS";
                break;
              case 'Small':
                s_min = "S";
                break;
              case 'Medium':
                s_min = "M";
                break;
              case 'Large':
                s_min = "L";
                break;
              case 'Extra Large':
                s_min = "XL";
                break;
              case 'Extra Extra Large':
                if(ptype=="Cheeky"||ptype=="Thong"){
                  s_min = "2X";
                }else{
                  s_min = "XXL";
                }
                break;
            }
            switch(item.properties.Style){
              case 'Standard':
              st_min = "No Fly";
              break;
            }
            if (ptype.indexOf("Boxer") != -1){
              item.variant_title = item.properties.Flavor + ' / ' + s_min + ' / ' + st_min;
            } else {
              item.variant_title = s_min;
            }
          }
        }
      }else if(item.properties['joined-product']){
        item.variant_title = item.variant_title + '\n' + 'Kimono Boxer Pack';
      // }else if(item.product_id == '4433868423237'){
      //   item.variant_title = item.properties['packSize'] + ' Pack Combo'
      }else if(item.properties['buildAPack'] || item.properties['buildAPack-2'] || item.properties['packProduct']){
        item.variant_title = item.variant_title + ' Pack Combo'
      }else if(item.properties['fromWomensListing']){
        item.title = item.properties['fromWomensTitle']
      }else if(item.id == 39327936446533){
        item.variant_title = "";
      }
      item.title = item.title.split("|")[0].trim();
      if(item.properties['mixedPackProduct']){
        item.title = item.properties['fromMixedPackTitle'] + ' Pack: ' + item.title
      }else if(item.properties['packMaster']){
        pid = item.properties.packID;
        v_title = "";
        if(CartJS.cart.items)var total=CartJS.cart.items.reduce(function(t,e){return pid!=e.properties.packID||e.properties.packMaster?t:(v_title+=e.title+" x "+e.quantity+" \n",t+e.line_price)},0);
        item.line_price = total;
        item.variant_title = v_title;
      }

      var key, value;
      for (key in item) {
        value = item[key];
        if (key !== 'properties') { this[key] = value; }
      }
      return this.properties = CartJS.Utils.extend({}, item.properties);
    };
    Item.prototype.propertyArray = function() {
      var name, value, _ref, _results;
      _ref = this.properties;
      _results = [];
      for (name in _ref) {
        value = _ref[name];
        _results.push({
          name: name,
          value: value
        });
      }
      return _results;
    };
    return Item;
  })();
  CartJS = {
    settings: {
      debug: false,
      dataAPI: true,
      requestBodyClass: null,
      rivetsModels: {},
      currency: null,
      moneyFormat: null,
      moneyWithCurrencyFormat: null,
      weightUnit: 'g',
      weightPrecision: 0
    },
    cart: new Cart()
  };
  CartCookie = {
    getJoinedItems: function() {
      // console.log('CartJS.Core.getJoinedItems(): ');
      if(this.joinedItems === undefined) {
        // set cookie here
        var joined_items = Cookies.get('ShinestyJoinedCart');
        if(!joined_items) {
          joined_items = [];
        } else { joined_items = JSON.parse(joined_items); }
        return this.setJoinedItems(joined_items);
      } else { return this.joinedItems; }
    },
    setJoinedItems: function(joined_items) {
      // console.log('CartJS.Core.setJoinedItems()');
      Cookies.set('ShinestyJoinedCart', JSON.stringify(joined_items), { expires: Infinity, path: '/'});
      this.joinedItems = joined_items;
      return this.joinedItems;
    }
  };
  CartJS.init = function(cart, settings) {
    if (settings == null) { settings = {}; }
    CartJS.configure(settings);
    CartJS.Utils.log('Initialising CartJS.');
    CartJS.cart.update(cart);
    if (CartJS.settings.dataAPI) {
      CartJS.Utils.log('"dataAPI" setting is true, initialising Data API.');
      CartJS.Data.init();
    }
    if (CartJS.settings.requestBodyClass) {
      CartJS.Utils.log('"requestBodyClass" set, adding event listeners.');
      jQuery(document).on('cart.requestStarted', function() {
        return jQuery('body').addClass(CartJS.settings.requestBodyClass);
      });
      jQuery(document).on('cart.requestComplete', function() {
        return jQuery('body').removeClass(CartJS.settings.requestBodyClass);
      });
    }
    CartJS.Rivets.init();
    return jQuery(document).trigger('cart.ready', [CartJS.cart]);
  };
  CartJS.configure = function(settings) {
    if (settings == null) { settings = {}; }
    return CartJS.Utils.extend(CartJS.settings, settings);
  };
  if (window.console == null) {
    window.console = {};
    window.console.log = function() {};
  }
  CartJS.Utils = {
    log: function() { return CartJS.Utils.console(console.log, arguments); },
    error: function() { return CartJS.Utils.console(console.error, arguments); },
    console: function(method, args) {
      if (CartJS.settings.debug && (typeof console !== "undefined" && console !== null)) {
        args = Array.prototype.slice.call(args);
        args.unshift('[CartJS]:');
        return method.apply(console, args);
      }
    },
    wrapKeys: function(obj, type, override) {
      var key, value, wrapped;
      if (type == null) { type = 'properties'; }
      wrapped = {};
      for (key in obj) {
        value = obj[key];
        wrapped["" + type + "[" + key + "]"] = override != null ? override : value;
      }
      return wrapped;
    },
    unwrapKeys: function(obj, type, override) {
      var key, unwrapped, unwrappedKey, value;
      if (type == null) { type = 'properties'; }
      unwrapped = {};
      for (key in obj) {
        value = obj[key];
        unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
        unwrapped[unwrappedKey] = override != null ? override : value;
      }
      return unwrapped;
    },
    extend: function(object, properties) {
      var key, val;
      for (key in properties) {
        val = properties[key];
        object[key] = val;
      }
      return object;
    },
    clone: function(object) {
      var key, newInstance;
      if ((object == null) || typeof object !== 'object') { return object; }
      newInstance = new object.constructor();
      for (key in object) { newInstance[key] = clone(object[key]); }
      return newInstance;
    },
    isArray: Array.isArray || function(value) {
      return {}.toString.call(value) === '[object Array]';
    },
    ensureArray: function(value) {
      if (CartJS.Utils.isArray(value)) { return value; }
      if (value != null) {
        return [value];
      } else { return []; }
    },
    formatMoney: function(value, format, formatName, currency) {
      var _ref, _ref1;
      if (currency == null) { currency = ''; }
      if (!currency) { currency = CartJS.settings.currency; }
      if ((window.Currency != null) && currency !== CartJS.settings.currency) {
        value = Currency.convert(value, CartJS.settings.currency, currency);
        if ((((_ref = window.Currency) != null ? _ref.moneyFormats : void 0) != null) && (currency in window.Currency.moneyFormats)) {
          format = window.Currency.moneyFormats[currency][formatName];
        }
      }
      if (((_ref1 = window.Shopify) != null ? _ref1.formatMoney : void 0) != null) {
        return Shopify.formatMoney(value, format);
      } else { return value; }
    },
    getSizedImageUrl: function(src, size) {
      var _ref, _ref1;
      if (((_ref = window.Shopify) != null ? (_ref1 = _ref.Image) != null ? _ref1.getSizedImageUrl : void 0 : void 0) != null) {
        if (src) {
          return Shopify.Image.getSizedImageUrl(src, size);
        } else {
          return Shopify.Image.getSizedImageUrl('https://cdn.shopify.com/s/images/admin/no-image-.gif', size).replace('-_', '-');
        }
      } else {
        if (src) {
          return src;
        } else { return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif'; }
      }
    }
  };
  queue = [];
  processing = false;
  CartJS.Queue = {
    add: function(url, data, options) {
      if( data["properties[buildAPack]"] || data['buildAPack-2'] || data['packProduct'] || data['sub_buy_now'] || data['mixedPackProduct']){
        $(".se-pre-con").fadeIn("fast");
        $(".pre-con-pack-icon").fadeIn("fast");
      }
      var request;
      if (options == null) { options = {}; }
      request = {
        url: url,
        data: data,
        type: options.type || 'POST',
        dataType: options.dataType || 'json',
        success: CartJS.Utils.ensureArray(options.success),
        error: CartJS.Utils.ensureArray(options.error),
        complete: CartJS.Utils.ensureArray(options.complete)
      };
      if (options.updateCart) { request.success.push(CartJS.cart.update); }
      queue.push(request);
      if (processing) { return; }
      jQuery(document).trigger('cart.requestStarted', [CartJS.cart]);
      return CartJS.Queue.process();
    },
    process: function() {
      var params;
      if (!queue.length) {
        processing = false;
        jQuery(document).trigger('cart.requestComplete', [CartJS.cart]);
        return;
      }
      processing = true;
      params = queue.shift();
      params.complete = CartJS.Queue.process;
      return jQuery.ajax(params);
    }
  };
  CartJS.Core = {
    getCart: function(options) {
      if (options == null) { options = {}; }
      options.type = 'GET';
      options.updateCart = true;
      return CartJS.Queue.add('/cart.js', {}, options);
    },
    addItem: function(id, quantity, properties, options) {
      // console.log('CartJS.Core.addItem()');
      var data;
      if (quantity == null) { quantity = 1; }
      if (properties == null) { properties = {}; }
      if (options == null) { options = {}; }
      if( Shopify.active_subscriber && Shopify.subscriber_pricing ){ properties["subPriceShopping"] = true; }
      data = CartJS.Utils.wrapKeys(properties);
      data.id = id;
      data.quantity = quantity;
      // addTUBAction({ 'action' : 'addItem', 'value' : {'id': id, 'quantity': quantity, 'properties': properties, 'options': options} });
      CartJS.Queue.add('/cart/add.js', data, options);
      return CartJS.Core.getCart();
    },
    addJoinItem: function(id, quantity, joinedIds, parentItem, callback) {
      // console.log('CartJS.Core.addItem()');

      // addTUBAction({ 'action' : 'addJoinItem', 'value' : {'id': id, 'quantity': quantity, 'joinedIds': joinedIds, 'parentItem': parentItem} });
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: {id: id, quantity: quantity},
        success: function(itemData) {

          // addTUBAction({ 'action' : 'addJoinItemSuccess', 'value' : {'id': id, 'quantity': quantity, 'joinedIds': joinedIds, 'parentItem': parentItem} });

          var index = joinedIds.indexOf(id);
          if(index > -1) joinedIds.splice(index, 1);
          if(joinedIds.length == 0) callback(parentItem);

          for(var i in joinedIds) {
            CartJS.Core.addJoinItem(joinedIds[i], quantity, JSON.parse(JSON.stringify(joinedIds)), parentItem, callback);
            break;
          }
        }
      });
    },
    joinItems: function(joinedIds, parentItem, addedQuantity, callback) {
      // console.log('CartJS.Core.joinItems()');

      // addTUBAction({ 'action' : 'joinItems', 'value' : {'joinedIds': joinedIds, 'parentItem': parentItem, 'addedQuantity': addedQuantity} });
      if (addedQuantity == null) addedQuantity = 1;
      // get currently joined items
      var joined_items = CartCookie.getJoinedItems();
      var new_joined_items = [];
      var added = false;
      for(var i in joined_items) {
        if(joined_items[i].parentId == parentItem.id && $(joined_items[i].joinedIds).not(joinedIds).length === 0 && $(joinedIds).not(joined_items[i].joinedIds).length === 0) {
          joined_items[i].quantity += addedQuantity;
          added = true;
        }
      }
      if(added == false) { joined_items.push({'parentId': parentItem.id, 'joinedIds': joinedIds, 'quantity': addedQuantity}); }
      CartCookie.setJoinedItems(joined_items);

      if(joinedIds.length == 0) callback();
      for(var i in joinedIds) {
        CartJS.Core.addJoinItem(joinedIds[i], addedQuantity, JSON.parse(JSON.stringify(joinedIds)), parentItem, callback);
        break;
      }

    },
    updateItem: function(line, quantity, properties, options) {
      // console.log('CartJS.Core.updateItem()');
      var data;
      if (properties == null) { properties = {}; }
      if (options == null) { options = {}; }
      if( Shopify.active_subscriber && Shopify.subscriber_pricing ){ properties["subPriceShopping"] = true; }
      data = CartJS.Utils.wrapKeys(properties);
      data.line = line;
      if (quantity != null) { data.quantity = quantity; }
      options.updateCart = true;

      // addTUBAction({ 'action' : 'updateItem', 'value' : {'line': line, 'quantity': quantity, 'properties': properties, 'options': options} });
      return CartJS.Queue.add('/cart/change.js', data, options);
    },
    removeItem: function(line, options) {
      // console.log('CartJS.Core.removeItem()');
      if (options == null) { options = {}; }
      return CartJS.Core.updateItem(line, 0, {}, options);
    },
    updateItemById: function(id, quantity, properties, options) {
      // console.log('CartJS.Core.updateItemById()');
      var data;
      if (properties == null) { properties = {}; }
      if (options == null) { options = {}; }
      if( Shopify.active_subscriber && Shopify.subscriber_pricing ){ properties["subPriceShopping"] = true; }
      data = CartJS.Utils.wrapKeys(properties);
      data.id = id;
      if (quantity != null) { data.quantity = quantity; }
      options.updateCart = true;
      // addTUBAction({ 'action' : 'updateItemById', 'value' : {'id': id, 'quantity': quantity, 'properties': properties, 'options': options} });
      return CartJS.Queue.add('/cart/change.js', data, options);
    },
    updateItemQuantitiesById: function(updates, options) {
      // console.log('CartJS.Core.updateItemQuantitiesById()');
      if (updates == null) { updates = {}; }
      if (options == null) { options = {}; }
      options.updateCart = true;
      // addTUBAction({ 'action' : 'updateItemQuantitiesById', 'value' : {'updates': updates, 'options': options} });
      return CartJS.Queue.add('/cart/update.js', {
        updates: updates
      }, options);
    },
    removeItemById: function(id, options) {
      // console.log('CartJS.Core.removeItemById()');
      var data;
      if (options == null) { options = {}; }
      data = {
        id: id,
        quantity: 0
      };
      options.updateCart = true;
      // addTUBAction({ 'action' : 'removeItemById', 'value' : {'id': id, 'options': options} });
      return CartJS.Queue.add('/cart/change.js', data, options);
    },
    removeSingleItemById: function(id, options) {
      console.log('CartJS.Core.removeSingleItemById()');
      try{
        q = CartJS.cart.items.find(i=>i.id == id && i.properties[options]).quantity
      }catch(e){
        q = false
      }
      ind = CartJS.cart.items.findIndex(i=>i.id == id && i.properties[options])
      options = {};

      if(ind>-1 && q){
        options.updateCart = true;
        return CartJS.Core.updateItem(ind+1, q-1, {}, options);
      }
      // return CartJS.Queue.add('/cart/change.js', data, options);
    },
    clear: function(options) {
      if (options == null) { options = {}; }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/clear.js', {}, options);
    },
    hasSubscription: function() {
      return CartJS.cart.items.some((item) => { return (item.product_type == "Conjured Subscription") })
    },
    getAttribute: function(attributeName, defaultValue) {
      if (attributeName in CartJS.cart.attributes) {
        return CartJS.cart.attributes[attributeName];
      } else { return defaultValue; }
    },
    setAttribute: function(attributeName, value, options) {
      var attributes;
      if (options == null) { options = {}; }
      attributes = {};
      attributes[attributeName] = value;
      return CartJS.Core.setAttributes(attributes, options);
    },
    getAttributes: function() {
      return CartJS.cart.attributes;
    },
    setAttributes: function(attributes, options) {
      if (attributes == null) { attributes = {}; }
      if (options == null) { options = {}; }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', CartJS.Utils.wrapKeys(attributes, 'attributes'), options);
    },
    clearAttributes: function(options) {
      if (options == null) { options = {}; }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', CartJS.Utils.wrapKeys(CartJS.Core.getAttributes(), 'attributes', ''), options);
    },
    getNote: function() {
      return CartJS.cart.note;
    },
    setNote: function(note, options) {
      if (options == null) { options = {}; }
      options.updateCart = true;
      return CartJS.Queue.add('/cart/update.js', {
        note: note
      }, options);
    }
  };
  $document = jQuery(document);
  CartJS.Data = {
    init: function() {
      CartJS.Data.setEventListeners('on');
      return CartJS.Data.render(null, CartJS.cart);
    },
    destroy: function() {
      return CartJS.Data.setEventListeners('off');
    },
    setEventListeners: function(method) {
      $document[method]('click', '[data-cart-add]', CartJS.Data.add);
      $document[method]('click', '[data-cart-remove]', CartJS.Data.remove);
      $document[method]('click', '[data-cart-remove-id]', CartJS.Data.removeById);
      $document[method]('click', '[data-cart-remove-pack]', CartJS.Data.removePack);
      $document[method]('click', '[data-cart-update]', CartJS.Data.update);
      $document[method]('click', '[data-cart-update-id]', CartJS.Data.updateById);
      $document[method]('click', '[data-cart-clear]', CartJS.Data.clear);
      $document[method]('change', '[data-cart-toggle]', CartJS.Data.toggle);
      $document[method]('change', '[data-cart-toggle-attribute]', CartJS.Data.toggleAttribute);
      $document[method]('submit', '[data-cart-submit]', CartJS.Data.submit);
      return $document[method]('cart.requestComplete', CartJS.Data.render);
    },
    add: function(e) {
      console.log('test');
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.addItem($this.attr('data-cart-add'), $this.attr('data-cart-quantity'));
    },
    remove: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      // don't use this if you're using joined products!
      return CartJS.Core.removeItem($this.attr('data-cart-remove'));
    },
    removePack: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      var packID = CartJS.cart.items[$this.attr('data-cart-remove-pack')-1].properties["packID"];
      for (var i = CartJS.cart.items.length - 1; i >= 0; --i) {
        if(CartJS.cart.items[i].properties["packID"]==packID&&(CartJS.cart.items[i].properties["buildAPack"])){
           CartJS.Core.removeItem(i+1);
        }
      }
    },
    removeById: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      var updateQuantities = {};
      // check for joined products
      var joinedProducts = [];
      $this.closest('div.mini-cart-item').find('input.jp').each(function() {
        var new_quantity = parseInt($(this).attr('data-total-quantity'))-parseInt($(this).attr('data-parent-quantity'));
        //CartJS.Core.updateItemById($(this).attr('data-id'), new_quantity);
        updateQuantities[$(this).attr('data-id')] = new_quantity;
        joinedProducts.push($(this).attr('data-id'));
      });
      // update joined products cookie
      var joinedProductCookie = CartCookie.getJoinedItems();
      var newJoinedProducts = [];
      for(var i in joinedProductCookie) {
        if(joinedProductCookie[i].parentId == $this.attr('data-cart-remove-id') && $(joinedProductCookie[i].joinedIds).not(joinedProducts).length === 0 && $(joinedProducts).not(joinedProductCookie[i].joinedIds).length === 0) {
          // don't add it
        } else { newJoinedProducts.push(joinedProductCookie[i]); }
      }
      CartCookie.setJoinedItems(newJoinedProducts);
      var new_quantity = parseInt($(this).attr('data-total-quantity'))-parseInt($(this).attr('data-quantity'));
      updateQuantities[$this.attr('data-cart-remove-id')] = new_quantity;
      return CartJS.Core.updateItemQuantitiesById(updateQuantities);
    },
    update: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      // don't use this if you're using joined products!
      return CartJS.Core.updateItem($this.attr('data-cart-update'), $this.attr('data-cart-quantity'));
    },
    updateById: function(e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      var lineitem_quantity_diff = parseInt($(this).attr('data-cart-quantity'))-parseInt($(this).attr('data-current-cart-quantity'));
      var lineitem_quantity = parseInt($(this).attr('data-current-line-item-quantity'))+parseInt(lineitem_quantity_diff);
      var updateQuantities = {};
      // check for joined products
      var joinedProducts = [];
      $this.closest('div.mini-cart-item').find('input.jp').each(function() {
        var new_quantity = parseInt($(this).attr('data-total-quantity'))+parseInt(lineitem_quantity_diff);
        updateQuantities[$(this).attr('data-id')] = new_quantity;
        //CartJS.Core.updateItemById($(this).attr('data-id'), new_quantity);
        joinedProducts.push($(this).attr('data-id'));
      });
      // update joined products cookie
      var joinedProductCookie = CartCookie.getJoinedItems();
      var newJoinedProducts = [];
      for(var i in joinedProductCookie) {
        if(joinedProductCookie[i].parentId == $this.attr('data-cart-update-id')) {
          if($(joinedProductCookie[i].joinedIds).not(joinedProducts).length === 0 && $(joinedProducts).not(joinedProductCookie[i].joinedIds).length === 0) {
            // update quantity
            joinedProductCookie[i].quantity = lineitem_quantity;
            if(lineitem_quantity !== 0) newJoinedProducts.push(joinedProductCookie[i]);
          } else { newJoinedProducts.push(joinedProductCookie[i]); }
        } else { newJoinedProducts.push(joinedProductCookie[i]); }
      }
      CartCookie.setJoinedItems(newJoinedProducts);
      //return CartJS.Core.updateItemById($this.attr('data-cart-update-id'), $this.attr('data-cart-quantity'));
      updateQuantities[$this.attr('data-cart-update-id')] = $this.attr('data-cart-quantity');
      return CartJS.Core.updateItemQuantitiesById(updateQuantities);
    },
    clear: function(e) {
      e.preventDefault();
      return CartJS.Core.clear();
    },
    toggle: function(e) {
      var $input, id;
      $input = jQuery(this);
      id = $input.attr('data-cart-toggle');
      if ($input.is(':checked')) {
        return CartJS.Core.addItem(id);
      } else { return CartJS.Core.removeItemById(id); }
    },
    toggleAttribute: function(e) {
      var $input, attribute;
      $input = jQuery(this);
      attribute = $input.attr('data-cart-toggle-attribute');
      return CartJS.Core.setAttribute(attribute, $input.is(':checked') ? 'Yes' : '');
    },
    submit: function(e) {
      var dataArray, id, properties, quantity;
      e.preventDefault();

      // addTUBAction({ 'action' : 'formSubmitted', 'value' : {'data': jQuery(this).serializeArray() } });
      $('.add-to-cart').trigger('click');
      return;

      dataArray = jQuery(this).serializeArray();
      id = void 0;
      quantity = void 0;
      properties = {};
      jQuery.each(dataArray, function(i, item) {
        if (item.name === 'id') { return id = item.value;
        } else if (item.name === 'quantity') { return quantity = item.value;
        } else if (item.name === 'variantID') { // do nothing
        } else { return properties[item.name] = item.value; }
      });
      // addTUBAction({ 'action' : 'formSubmitted', 'value' : {'id': id, 'quantity': quantity, 'properties': properties } });
      return CartJS.Core.addItem(id, quantity, CartJS.Utils.unwrapKeys(properties));
    },
    render: function(e, cart) {
      var _i, _len, unjoined_item_count = 0;
      for (_i = 0, _len = cart.items.length; _i < _len; _i++) {
        if(cart.items[_i].handle.indexOf('-joinedproduct') === -1) { unjoined_item_count += cart.items[_i].quantity; }
      }
      var context;
      context = {
        'item_count': unjoined_item_count,
        'total_price': cart.total_price,
        'total_price_money': CartJS.Utils.formatMoney(cart.total_price, CartJS.settings.moneyFormat, 'money_format', (typeof Currency !== "undefined" && Currency !== null ? Currency.currentCurrency : void 0) != null ? Currency.currentCurrency : void 0),
        'total_price_money_with_currency': CartJS.Utils.formatMoney(cart.total_price, CartJS.settings.moneyWithCurrencyFormat, 'money_with_currency_format', (typeof Currency !== "undefined" && Currency !== null ? Currency.currentCurrency : void 0) != null ? Currency.currentCurrency : void 0)
      };
      return jQuery('[data-cart-render]').each(function() {
        var $this;
        $this = jQuery(this);
        return $this.html(context[$this.attr('data-cart-render')]);
      });
    }
  };
  if ('rivets' in window) {
    CartJS.Rivets = {
      model: null,
      boundViews: [],
      init: function() { return CartJS.Rivets.bindViews(); },
      destroy: function() { return CartJS.Rivets.unbindViews(); },
      bindViews: function() {
        CartJS.Utils.log('Rivets.js is present, binding views.');
        CartJS.Rivets.unbindViews();
        CartJS.Rivets.model = CartJS.Utils.extend({
          cart: CartJS.cart
        }, CartJS.settings.rivetsModels);
        if (window.Currency != null) { CartJS.Rivets.model.Currency = window.Currency; }
        return jQuery('[data-cart-view]').each(function() {
          var view;
          view = rivets.bind(jQuery(this), CartJS.Rivets.model);
          return CartJS.Rivets.boundViews.push(view);
        });
      },
      unbindViews: function() {
        var view, _i, _len, _ref;
        _ref = CartJS.Rivets.boundViews;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          view = _ref[_i];
          view.unbind();
        }
        return CartJS.Rivets.boundViews = [];
      }
    };
    rivets.formatters.eq = function(a, b) { return a === b; };
    rivets.formatters.noteq = function(a, b) { return a != b; }
    rivets.formatters.includes = function(a, b) { return a.indexOf(b) >= 0; };
    rivets.formatters.contains = function(a, b) {
      c=[];
      for(var i = 0; i < a.length; i++){c.push(a[i]['product_id']);}
      return (c.indexOf(b) !== -1); return false;
    };
    rivets.formatters.containsType = function(a, b) {
      for(var e=0;e<a.length;e++){
        if(a[e]['product_type']==b)return!0;
      }
      return!1
    };
    rivets.formatters.containsSubBanner = function(a) {
      for(var e=0;e<a.length;e++){
        if(a[e].properties["PodDiscount"]=='Bert')
          return!0;
      }
      return!1
    };
    rivets.formatters.annual_sub_renewal = function(a) {
      if(a.indexOf("XFPPAY") != -1 || a.indexOf("BXPPAY") != -1 || a.indexOf("BFPPAY") != -1) return "Renews Annually At 159.99";
      else if(a.indexOf("TGPPAY") != -1) return "Renews Annually At 99.99";
      else if(a.indexOf("CUPPAY") != -1 || a.indexOf("SUPPAY") != -1 || a.indexOf("KUPPAY") != -1 || a.indexOf("") != -1) return "Renews Annually At 119.90";
      else return "";
    };
    rivets.formatters.match = function(a, regexp, flags) { return a.match(new RegExp(regexp, flags)); };
    rivets.formatters.lt = function(a, b) { return a < b; };
    rivets.formatters.lteq = function(a, b) { return a <= b; };
    rivets.formatters.gt = function(a, b) { return a > b; };
    rivets.formatters.gteq = function(a, b) { return a >= b; };
    rivets.formatters.not = function(a) { return !a; };
    rivets.formatters.empty = function(a) { return !a.length; };
    rivets.formatters.plus = function(a, b) { return parseInt(a) + parseInt(b); };
    rivets.formatters.minus = function(a, b) { return parseInt(a) - parseInt(b); };
    rivets.formatters.prepend = function(a, b) { return b + a; };
    rivets.formatters.append = function(a, b) { return a + b; };
    rivets.formatters.hasLineDiscountPart = function(a, b) {
      var x = a.every(i=>{ if(i.title.indexOf(b)!=-1){return true;} });
      return x;
    }
    rivets.formatters.htc_discount = function(value, currency) { return (value * 0.7); };
    rivets.formatters.bx_discount = function(value, currency) { return (value * 0.8); };
    rivets.formatters.money = function(value, currency) { return CartJS.Utils.formatMoney(value, CartJS.settings.moneyFormat, 'money_format', currency); };
    rivets.formatters.money_with_currency = function(value, currency) { return CartJS.Utils.formatMoney(value, CartJS.settings.moneyWithCurrencyFormat, 'money_with_currency_format', currency); };
    rivets.formatters.money_without_currency = function(value) { return "<span class='cart--dollar-sign'>$</span>"+(value/100).toFixed(2); };
    rivets.formatters.money_no_currency = function(value) { return (value/100).toFixed(2); };
    rivets.formatters.money_round = function(value) { return Math.floor(value); };
    rivets.formatters.weight = function(grams) {
      switch (CartJS.settings.weightUnit) {
        case 'kg': return (grams / 1000).toFixed(CartJS.settings.weightPrecision);
        case 'oz': return (grams * 0.035274).toFixed(CartJS.settings.weightPrecision);
        case 'lb': return (grams * 0.00220462).toFixed(CartJS.settings.weightPrecision);
        default: return grams.toFixed(CartJS.settings.weightPrecision);
      }
    };
    rivets.formatters.weight_with_unit = function(grams) { return rivets.formatters.weight(grams) + CartJS.settings.weightUnit; };
    rivets.formatters.product_image_size = function(src, size) { return CartJS.Utils.getSizedImageUrl(src, size); };
    rivets.formatters.getProperty = function(properties, prop) { return properties[prop] };
    rivets.formatters.hasProperty = function(properties, prop) { return properties[prop] };
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency;
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit;
    rivets.formatters.productImageSize = rivets.formatters.product_image_size;
    rivets.formatters.underwear_count = function(items){
      var x = 0;
      for(i=0;i<items.length;i++){
        if(items[i].product_type.indexOf('Boxer')!=-1){
          x+=items[i].quantity;
        }
        if(items[i].product_type.indexOf('Thong')!=-1){
          x+=items[i].quantity;
        }
        if(items[i].product_type.indexOf('Cheeky')!=-1){
          x+=items[i].quantity;
        }
        if(items[i].product_type.indexOf('Boyshort')!=-1){
          x+=items[i].quantity;
        }
        if(items[i].product_type.indexOf('Bikini')!=-1){
          x+=items[i].quantity;
        }
      }
      const modulo = x % 4;
      const addPairs = (4 - modulo);
      if(addPairs == 4) {
        return `You've got free undies in your cart`;
      }
      if(addPairs == 1) {
        return `You did it, Champ, your next pair is free.`
      }
      const pairPlural = (addPairs == 1)
      ? 'pair'
      : 'pairs'
      const freePair = (x + addPairs);
      return `Add ${addPairs} ${pairPlural} get the ${freePair}th free.`;
    };
  } else {
    CartJS.Rivets = {
      init: function() {},
      destroy: function() {}
    };
  }
  CartJS.factory = function(exports) {
    exports.init = CartJS.init;
    exports.configure = CartJS.configure;
    exports.cart = CartJS.cart;
    exports.settings = CartJS.settings;
    exports.getCart = CartJS.Core.getCart;
    exports.addItem = CartJS.Core.addItem;
    exports.getJoinedItems = CartJS.Core.getJoinedItems;
    exports.setJoinedItems = CartJS.Core.setJoinedItems;
    exports.joinItems = CartJS.Core.joinItems;
    exports.updateItem = CartJS.Core.updateItem;
    exports.updateItemById = CartJS.Core.updateItemById;
    exports.updateItemQuantitiesById = CartJS.Core.updateItemQuantitiesById;
    exports.removeItem = CartJS.Core.removeItem;
    exports.removeItemById = CartJS.Core.removeItemById;
    exports.removeSingleItemById = CartJS.Core.removeSingleItemById;
    exports.clear = CartJS.Core.clear;
    exports.hasSubscription = CartJS.Core.hasSubscription;
    exports.getAttribute = CartJS.Core.getAttribute;
    exports.setAttribute = CartJS.Core.setAttribute;
    exports.getAttributes = CartJS.Core.getAttributes;
    exports.setAttributes = CartJS.Core.setAttributes;
    exports.clearAttributes = CartJS.Core.clearAttributes;
    exports.getNote = CartJS.Core.getNote;
    exports.setNote = CartJS.Core.setNote;
    return exports.render = CartJS.Data.render;
  };
  if (typeof exports === 'object') {
    CartJS.factory(exports);
  } else if (typeof define === 'function' && define.amd) {
    define(['exports'], function(exports) {
      CartJS.factory(this.CartJS = exports);
      return exports;
    });
  } else { CartJS.factory(this.CartJS = {}); }

  $(document).on('cart.requestComplete', function(event, cart) {
    if(cart.item_count == 0) {
      CartCookie.setJoinedItems([]);
      $('.mini-cart-carousel').css('display','none');
      $('.cart-items-count').addClass('hidden');
    }
    else {
      var has_womens = false;
      $('.mini-cart-carousel').css('display','block');
      $('.cart-items-count').removeClass('hidden');
      $('.cart-items-count').text(cart.item_count);
      if(!$('.mini-cart-carousel').hasClass('slick-initialized')) {
        $('.mini-cart-carousel').slick({
          lazyLoad: 'ondemand',
          prevArrow: "<div class='slick-prev' style='left:9px;position:absolute;top:45%;z-index:1;'><i class='fa fa-angle-left' style='color:#E4002B;font-size:32px;' aria-hidden='true'></i></div>",
          nextArrow: "<div class='slick-next' style='right:9px;position:absolute;top:45%;z-index:1;'><i class='fa fa-angle-right' style='color:#E4002B;font-size:32px;' aria-hidden='true'></i></div>",
          dots: false,
          rows: 0,
          infinite: true,
          centerPadding: '0px',
          slidesToShow: 1,
          swipeToSlide: true
        }).on('setPosition', function (event, slick) {
           // slick.$slides.css('height', slick.$slideTrack.height() + 'px');
           $('.mini-cart-upsell-item.item.slick-slide.slick-active').css({'height':slick.$slideTrack.height() + 'px','max-height':'180px'});
        });
      }
      if($('.mini-cart-carousel').hasClass('slick-initialized')) {
        if(cart.items[0].handle.includes('cheeky') || cart.items[0].handle.includes('thong')) {
          has_womens = true;
          $('.mini-cart-carousel').addClass('cart-has-women');
          $('.mini-cart-carousel .mini-cart-upsell-item:not(".has-women")').css('order','2');
          $('.mini-cart-carousel .mini-cart-upsell-item.has-women').css('order','1');
        }
      }
    }
    if(!toCheckoutClicked){
      $(".se-pre-con").fadeOut("fast");
      $(".pre-con-icon").fadeOut("fast");
      $(".pre-con-pack-icon").fadeOut("fast");
    }
    var has_subscription, hasPJtop, hasPJbottom, has_pjs, has_slippers, has_quarantine, has_miniupsell, has_second_miniupsell, has_stpatty = false;
    var gift_count = 0;
    var boxer_count = 0;
    var mixed_boxer_count = 0;
    var mixed_product_count = 0;
    var father_count = 0;
    var father_box_count = 0;
    var father_cream_count = 0;
    var sunglasses_count = 0;
    var sunglasses_case_count = 0;
    var marga_count = 0;
    var marga_box_count = 0;
    var cart_variant_ids = [];
    var cart_prod_ids = [];
    var c_pid_nums = [];
    var cartItems = {};
    var cartPrice = CartJS.cart.items_subtotal_price/100;
    console.log(cart.items);
    // const testGroupName = window.igData?.user.getTestGroupName('af187e85-ba19-46e4-b7ca-aec8377fa9f2')

    // Counting Loop
    for(var i in cart.items) {
      if (cart.items[i].id){
        if(cart.items[i].product_id == 4624624451653){
          gift_count+=cart.items[i].quantity
        }
        else if(cart.items[i].product_type.indexOf('Boxer')!=-1 && (cart.items[i].properties['buildAPack'] || cart.items[i].properties['packProduct'])){
          boxer_count+=cart.items[i].quantity;
          if(cart.items[i].properties["fromPackProduct"] == 6594602336325){
            father_count+=cart.items[i].quantity;
          }
          if(cart.items[i].product_id == 4676102488133||cart.items[i].product_id == 4676102520901||cart.items[i].product_id == 4676102455365||cart.items[i].product_id == 4676102422597||cart.items[i].product_id == 4675987210309||cart.items[i].product_id == 4675987177541) {
            marga_count+=cart.items[i].quantity;
          }
        }
        else if(cart.items[i].product_id == 6579445203013){father_box_count+=cart.items[i].quantity}
        else if(cart.items[i].product_id == 4484210425925 && cart.items[i].properties.promotional){father_cream_count+=cart.items[i].quantity}
        else if(cart.items[i].product_id == 1653430157381){boxer_count+=cart.items[i].quantity}
        else if(cart.items[i].product_id == 4345416319045){boxer_count+=(cart.items[i].quantity*3)}
        else if(cart.items[i].properties['sunglassesJoinType']) {
          sunglasses_count+=cart.items[i].quantity;
        }
        else if(cart.items[i].product_id == 6126842692) {
          sunglasses_case_count+=cart.items[i].quantity;
        }
        else if(cart.items[i].product_id == 6585924223045){marga_box_count+=cart.items[i].quantity}

        if((cart.items[i].properties['mixedPackProduct'] || cart.items[i].properties['fromMixedPackProduct'])) {
          mixed_product_count += cart.items[i].quantity;
          if(cart.items[i].product_type.indexOf('Boxer')!=-1){
            mixed_boxer_count += cart.items[i].quantity;
          }
        }
        if(cart.items[i].properties.isQuarantine) has_quarantine = true;
        if(cart.items[i].properties.isStPatty) has_stpatty = true;
        if(cart.items[i].properties.minicartUpsell && !$('.mini-cart-upsell').hasClass('no-upsell')) has_miniupsell = true;
        if(cart.items[i].properties.minicartUpsell2 && !$('.mini-cart-upsell').hasClass('no-upsell')) has_second_miniupsell = true;
        if(cart.items[i].product_type == 'Conjured Subscription') {
          has_subscription = true;
          if(cart.items[i].handle == "monthly-boxer-subscription") {
            // singleBoxerPrice = singleBoxerPrices[testGroupName];
            // cart.items[i].original_line_price = String(singleBoxerPrice * cart.items[i].quantity);
            cart.items[i].original_line_price = '1699'
          }
          if(cart.items[i].handle == "monthly-cheeky-subscription") {cart.items[i].original_line_price = '1799'}
          if(cart.items[i].handle == "quarterly-boxer-subscription") {cart.items[i].original_line_price = '1799'}
          if(cart.items[i].handle == "monthly-thong-subscription") {cart.items[i].original_line_price = '1499'}
          if(cart.items[i].handle == "monthly-boxer-thong-subscription") {cart.items[i].original_line_price = '4299'}
        }

        if(cart.items[i].variant_id) {
          if(cart.items[i].product_type == 'Pajamas'){
            if (cart.items[i].product_title.indexOf('Pajama Top') == -1){
              hasPJtop = true;
            }else if (cart.items[i].product_title.indexOf('Pajama Bottom') == -1) {
              hasPJbottom = true;
            }
          }
          if(cartItems[cart.items[i].variant_id] !== undefined) {
            cartItems[cart.items[i].variant_id] = cartItems[cart.items[i].variant_id] + cart.items[i].quantity;
          } else {
            cartItems[cart.items[i].variant_id] = cart.items[i].quantity;
          }
        }
        cart_variant_ids.push(cart.items[i]["variant_id"]);
        cart_prod_ids.push(cart.items[i]["product_id"]);
        c_pid_nums[cart.items[i]["product_id"]] = cart.items[i].quantity;
      }
    }

    // Updating Loop
    for(var i in cart.items) {
      if(cart.items[i].id) {
        var item = cart.items[i];
        var li_discount = window.igData?.price.getDiscountByVariantId(item.id) || "";
        if (Number(cart.items[i].properties["_igLineItemDiscount"]) != Number(li_discount)) {
          CartJS.Core.updateItem(Number(i)+1, cart.items[i].quantity, {...cart.items[i].properties, "_igLineItemDiscount": li_discount});
        }
        item.original_line_price -= (Number(li_discount)*item.quantity)

      }

    }
    var correctJoinedItems = [];
    var joinedItems = CartCookie.getJoinedItems();
    // loop over joined items cookie
    for(var j in joinedItems) {
      if(cartItems[joinedItems[j].parentId] == undefined) continue;

      var lowestQuantity = joinedItems[j].quantity;
      if(lowestQuantity > cartItems[joinedItems[j].parentId]) lowestQuantity = cartItems[cartItems[joinedItems[j].parentId]];
      var matchedChildren = [];
      for(var c in joinedItems[j].joinedIds) {
        if(cartItems[joinedItems[j].joinedIds[c]] != undefined) {
          if(lowestQuantity > cartItems[joinedItems[j].joinedIds[c]]) lowestQuantity = cartItems[joinedItems[j].joinedIds[c]];
          matchedChildren.push(joinedItems[j].joinedIds[c]);
        }
      }

      correctJoinedItems.push({'parentId' : joinedItems[j].parentId, 'joinedIds': matchedChildren, 'quantity' : lowestQuantity});
      cartItems[joinedItems[j].parentId] = cartItems[joinedItems[j].parentId] - lowestQuantity;
      if(cartItems[joinedItems[j].parentId] <= 0) delete cartItems[joinedItems[j].parentId];
      for(var c in matchedChildren) {
        cartItems[matchedChildren[c]] = cartItems[matchedChildren[c]] - lowestQuantity;
        if(cartItems[matchedChildren[c]] <= 0) delete cartItems[matchedChildren[c]];
      }
    }
    CartCookie.setJoinedItems(correctJoinedItems);

    if (hasPJtop && hasPJbottom){
      has_pjs = true;
    }

    // Check sunglasses case match the number of special sunglasses
    if(sunglasses_count>0) {
      var needed_cases = sunglasses_count;

      if(needed_cases>0 && sunglasses_case_count==0){
        CartJS.Core.addItem(20509612740, 1);
      }
      else if(needed_cases>0 && needed_cases!=sunglasses_case_count) {
        CartJS.Core.updateItemById(20509612740, needed_cases);
      }
      else if(needed_cases==0 && sunglasses_case_count!=0){
        CartJS.Core.removeItemById(20509612740);
      }
    }

    // Check Margaritaville special packaging number match per 6 product
    if(marga_count>0){
      var needed_boxes = Math.floor(marga_count/6);

      if(needed_boxes>0&&marga_box_count==0){
        CartJS.Core.addItem(39327936446533, 1, {promotional:true});
      }else if(needed_boxes>0&&needed_boxes!=marga_box_count){
        CartJS.Core.updateItemById(39327936446533, needed_boxes);
      }else if(needed_boxes==0&&marga_box_count!=0){
        CartJS.Core.removeItemById(39327936446533);
      }else{
        // console.log("Good number of boxes");
      }
    }else if(marga_box_count>0){
      CartJS.Core.removeItemById(39327936446533);
    }

    if(has_subscription) {
      $('.additional-checkout-button').addClass("hidden");
      $('.mini-cart-upsell').addClass('has-subscription');
      $('.mini-cart-line-items').addClass('has-subscription');
      $('#checkout').addClass('conjured_checkout').removeClass('standard_checkout');
    //   $('.mini-cart-line-items').addClass('short-footer');
    // } else {
    //   $('.mini-cart-line-items').removeClass('short-footer');
    } else{
      $('.mini-cart-upsell').removeClass('has-subscription');
      $('.mini-cart-line-items').removeClass('has-subscription');
      $('.note_container').show();
      if(toCheckoutClicked){
        $('[name="checkout"]').click();
        $(".se-pre-con").fadeOut("slow");
        $(".pre-con-icon").fadeOut("slow");
        $(".pre-con-pack-icon").fadeOut("slow");
      }else{
        $('#checkout').removeClass('conjured_checkout').addClass('standard_checkout');
      }
    }


    if(has_miniupsell){
      if(has_second_miniupsell){
        $(".mini-cart-line-items").addClass('has-upsell');
        $(".mini-cart-upsell").addClass('hidden');
      }else{
        $(".mini-cart-line-items").removeClass('has-upsell');
        $(".mini-cart-upsell.upsell-1").addClass('hidden');
        $(".mini-cart-upsell.upsell-2").removeClass('hidden');
      }
    }else{
      $(".mini-cart-line-items").removeClass('has-upsell');
      $(".mini-cart-upsell.upsell-1").removeClass('hidden');
      $(".mini-cart-upsell.upsell-2").addClass('hidden');
    }
    if(LoopOnstore.isActive()){
      if(has_subscription){
        $('.mini-cart--loop-banner').removeClass('hidden');
      }else{
        $('.mini-cart--loop-banner').addClass('hidden');
      }

      $(".mini-cart-item").each(function(i,v) {
        if($(v).find('.mini-cart-price.line-through').length){
          $(v).find('.mini-cart-price').not('.line-through').addClass('hidden');
          $(v).find('.mini-cart-price.line-through').removeClass('line-through');
        }
      });
      if($('.mini-cart-subtotal.line-through').length){
        $('span.mini-cart-subtotal').not('.line-through').addClass('hidden');
        $('span.mini-cart-subtotal.line-through').removeClass('line-through');
      }
    }

    // if(cart_prod_ids.length){
      // var can_gototcheck = false;
      // console.log("Try from Upsell checkout");
      // if( $('.modal-gift-panel--container').attr('data-from-upsell')=="true" && !$('.free-gift-panel').length && $('.modal-gift-panel--container').attr('data-passed-tier')=="true" ){
      //   console.log("from Upsell, goto checkout?");
      //   $('#FreeGiftModal').modal('hide');
      //   $(".se-pre-con").fadeIn("fast");
      //   $(".pre-con-icon").fadeIn("fast");
      //   if(cartPrice>499){
      //     if(has_tier7) can_gototcheck=true;
      //   } else if(cartPrice>249){
      //     if(has_tier6) can_gototcheck=true;
      //   } else if(cartPrice>199){
      //     if(has_tier5) can_gototcheck=true;
      //   } else if(cartPrice>149){
      //     if(has_tier4) can_gototcheck=true;
      //   } else if(cartPrice>99){
      //     if(has_tier3) can_gototcheck=true;
      //   } else if(cartPrice>49){
      //     if(has_tier2) can_gototcheck=true;
      //   } else if(cartPrice>0){
      //     if(has_tier1) can_gototcheck=true;
      //   }
      //   if(can_gototcheck){
      //     if(has_subscription){
      //       window.location.href='/a/subscription/checkout';
      //     } else {
      //       window.location.href='/checkout';
      //     }
      //   }
      // }
    // }
    if(Shopify.money_back_sale){
    //getMoneyBack();
    }
    if(Shopify.stacking_gifts_sale){
    //  FreeGifts.ensure_cart_has_appropriate_free_gifts(cart_variant_ids, cart_prod_ids, cartPrice, c_pid_nums);
      // FreeGifts.remove_all_free_gifts_from_cart();
    }else if(Shopify.stacking_gifts_postsale){
  //    FreeGifts.remove_all_free_gifts_from_cart();
    }
  });
}).call(this);
